/**
 * Structured Logger — Display Client
 * ─────────────────────────────────────────────────────────────────────────────
 * Replaces ad-hoc console.log with structured, level-aware logging.
 * In production: errors are reported to Sentry; debug is suppressed.
 */

const LEVELS = { debug: 0, info: 1, warn: 2, error: 3 };
const CURRENT_LEVEL =
  LEVELS[import.meta.env.VITE_LOG_LEVEL] ?? (import.meta.env.PROD ? LEVELS.info : LEVELS.debug);

const format = (level, message, context) => {
  const timestamp = new Date().toISOString();
  const prefix = `[${timestamp}] [${level.toUpperCase()}]`;
  if (context) {
    return [prefix, message, context];
  }
  return [prefix, message];
};

export const logger = {
  debug(message, context) {
    if (CURRENT_LEVEL <= LEVELS.debug) {
      console.log(...format("debug", message, context));
    }
  },
  info(message, context) {
    if (CURRENT_LEVEL <= LEVELS.info) {
      console.info(...format("info", message, context));
    }
  },
  warn(message, context) {
    if (CURRENT_LEVEL <= LEVELS.warn) {
      console.warn(...format("warn", message, context));
    }
  },
  error(message, context) {
    if (CURRENT_LEVEL <= LEVELS.error) {
      console.error(...format("error", message, context));
    }
  },
};

export default logger;
